import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/api';

export default function NuevaPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('El link no es válido. Solicitá uno nuevo desde "Recuperar contraseña".');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres'); return; }
    if (!/(?=.*[a-zA-Z])(?=.*\d)/.test(password)) { setError('La contraseña debe tener letras y números'); return; }
    if (password !== confirmar) { setError('Las contraseñas no coinciden'); return; }

    setLoading(true);
    setError('');
    try {
      await authService.resetPassword(token, password);
      setExito(true);
    } catch (err) {
      setError(err.message || 'El link expiró o no es válido. Solicitá uno nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (exito) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-10 max-w-md w-full text-center">
          <div className="text-5xl mb-4">✅</div>
          <h2 className="text-2xl font-bold text-white mb-3">Contraseña actualizada</h2>
          <p className="text-gray-400 mb-8">Ya podés iniciar sesión con tu nueva contraseña.</p>
          <button
            onClick={() => navigate('/app')}
            className="w-full bg-[#ed6f28] hover:bg-[#c45e1e] text-white font-semibold py-3 rounded-xl transition-colors"
          >
            Ir al inicio de sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <button onClick={() => navigate('/')}>
            <img
              src="/logorentiacompletonaranjablanco.png"
              alt="Rentia"
              className="h-12 w-auto object-contain mx-auto"
            />
          </button>
        </div>

        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 shadow-xl">
          <h1 className="text-2xl font-bold text-white mb-1">Nueva contraseña</h1>
          <p className="text-gray-400 text-sm mb-6">Elegí una contraseña segura para tu cuenta.</p>

          {error && (
            <div className="mb-4 bg-red-900/40 border border-red-500 text-red-300 rounded-lg px-4 py-3 text-sm">
              {error}
            </div>
          )}

          {token && (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-gray-300 text-sm block mb-1.5">Nueva contraseña</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Mínimo 8 caracteres con letras y números"
                  disabled={loading}
                  className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
                />
              </div>

              <div>
                <label className="text-gray-300 text-sm block mb-1.5">Confirmar contraseña</label>
                <input
                  type="password"
                  value={confirmar}
                  onChange={e => setConfirmar(e.target.value)}
                  placeholder="Repetí la contraseña"
                  disabled={loading}
                  className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#ed6f28] hover:bg-[#c45e1e] text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
              </button>
            </form>
          )}

          {!token && (
            <button
              onClick={() => navigate('/recuperar-password')}
              className="w-full bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 rounded-xl transition-colors mt-2"
            >
              Solicitar nuevo link
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
